export default __webpack_public_path__ + "static/media/roadmap-head-shark-2.a44537a3.png";